import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SearchIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M17.2483 9.75167C17.2483 7.7622 16.4582 5.85422 15.0518 4.44746C13.6454 3.0407 11.738 2.25038 9.74905 2.25038C7.76012 2.25038 5.85265 3.0407 4.44627 4.44746C3.03988 5.85422 2.24978 7.7622 2.24978 9.75167C2.24978 11.7411 3.03988 13.6491 4.44627 15.0559C5.85265 16.4626 7.76012 17.2529 9.74905 17.2529C11.738 17.2529 13.6454 16.4626 15.0518 15.0559C16.4582 13.6491 17.2483 11.7411 17.2483 9.75167ZM15.8 17.3983C14.1408 18.7157 12.0363 19.5033 9.74905 19.5033C4.36364 19.5033 0 15.1385 0 9.75167C0 4.36481 4.36364 0 9.74905 0C15.1345 0 19.4981 4.36481 19.4981 9.75167C19.4981 12.0396 18.7107 14.1446 17.3936 15.8043L23.6696 22.0819C24.1101 22.5226 24.1101 23.2352 23.6696 23.6712C23.229 24.1072 22.5166 24.1119 22.0807 23.6712L15.8 17.3983Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default SearchIcon
